import {set} from 'lodash-es';

import utils from './coreutils';
import iam from './cb_iam';
import protector from './protector';
//import 'amazon-cognito-js';

set(window, 'cb.core.utils', utils);
set(window, 'cb.core.iam', iam);
set(window, 'cb.core.protector', protector);
